import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@mcdougald/ui/src';
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from 'next-themes';

/**
 * TODO - Add themeing
 */
const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();
  // const t = useTranslations()

  console.log('[ThemeSwitcher] rendered', {
    theme,
  });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id="Theme-Switcher-Button"
          data-umami-event="Theme-Switcher-Button"
          variant="ghost"
          className="size-9 p-0 text-gray-700"
          // aria-label={t('theme-toggle.toggle-theme')}
          data-testid="theme-toggle"
        >
          <SunIcon className="size-4 text-gray-700 dark:hidden" />
          <MoonIcon className="hidden text-gray-700 size-4 dark:block" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="gap-2"
          onClick={() => setTheme('light')}
          data-testid="theme-light-button"
          disabled
        >
          <SunIcon className="size-[18px]" /> Light
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-2"
          onClick={() => setTheme('dark')}
          data-testid="theme-dark-button"
        >
          <MoonIcon className="size-[18px]" /> Dark
        </DropdownMenuItem>
        <DropdownMenuItem
          className="gap-2"
          onClick={() => setTheme('system')}
          data-testid="theme-system-button"
          disabled
        >
          <MonitorIcon className="size-[18px]" /> System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeSwitcher;
